
$(document).on('click', '.js-day-filter', function() {
    $.ajax({
        url: '#',
        method: 'GET',
        data: {day: $( "input:checked" ).val()},
        contentType: 'script',
        success: function (data) {
            $('table tbody').replaceWith(data)
        }
    });
});
